import api from "."


export default {
    getPosts: async (page, limit, published) => {
        const res = await api.get(`/api/post`, {
            params: {
                page,
                limit,
                published,
            }
        });
        return res.data;
    },
    getPost: async (id) => {
        const res = await api.get(`/api/post/${id}`);
        return res.data;
    },
    createPost: async (data) => {
        const res = await api.post(`/api/post`, data);
        return res.status === 201;
    },
    updatePost: async (id, data) => {
        const res = await api.put(`/api/post/${id}`, data);
        return res.data;
    },
    deletePost: async (id) => {
        const res = await api.delete(`/api/post/${id}`);
        return res.data;
    },
    getPublishedPosts: async (page, limit) => {
        const res = await api.get(`/api/post/published`, {
            params: {
                page,
                limit,
            }
        });
        return res.data;
    }
}